/**
 * Enum for the different steps in the artwork submission flow
 */
export enum SubmissionStep {
  AGREEMENT = 'agreement',
  ARTWORK = 'artwork',
  ADDITIONAL_INFO = 'additional_info'
}
